module.exports = __webpack_public_path__ + "img/電気回路_2_4_2.898da05e.png";